/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

import type { SegmentProps } from './types';
export function Segment(props: SegmentProps) {
  return null;
}